module.exports = __webpack_public_path__ + "static/media/triangle1.d22b796f.svg";